import { AppTitles } from '../constants/global.constant';

/**
 * method is required for dynamic title creation
 * @param {string} brand - env.brand
 * @param {string} type - title type
 * @returns {string}
 */
const getTitle = (brand: string, type: string): string => {
  return AppTitles[brand][type];
};

export default getTitle;
